<div class="jbm-crud-title">
      <div class="title">{{caption}}</div>
</div>
